<div class='modal__header'>
  <h2 mat-dialog-title>{{ 'CONFIGURATOR|Przyczyny braku wyceny' | translate }}</h2>
  <mat-icon (click)='onNoClick()'>close</mat-icon>
</div>
<mat-dialog-content class="mat-typography">
  <mat-list>
    @for (seg of segments; track seg) {
      <mat-list-item >
        <span>{{seg.id}}. </span>
        <b>
          @if (seg.translatedType) {
            <span>{{seg.translatedType}}</span>
          }
          @if (seg.translatedName) {
            <span>: {{seg.translatedName}}</span>
          }
        </b>
        @if (seg.baseValue!==null) {
          <mat-icon class='segment --valid'>check</mat-icon>
        }
        @if (seg.baseValue===null) {
          <mat-icon class='segment --invalid'>close</mat-icon>
        }
      </mat-list-item>
    }
  </mat-list>
</mat-dialog-content>